import { Navigate, Route, Routes } from 'react-router-dom';
import Feeconfigs from './FeeConfigs/FeeConfigs';
import { keycloak } from '../../keycloak';
import { withRouter } from '../withRouter';

export const FeeConfigsRoutes = () => {
  const isItAdmin = keycloak.hasRealmRole('Role_IT_Administrator');

  return (
    <div className="app-wrapper h-100" style={{ padding: '100px' }}>
      <Routes>
        <Route
          path="fees"
          element={isItAdmin ? <Feeconfigs /> : <Navigate to={'/tff/common/error-403'} />}
        />
      </Routes>
    </div>
  );
};

export default withRouter(FeeConfigsRoutes);
